import React from 'react';
import styles from './ValuesSection.module.css';
import sketchImg from '../../assets/SKETCHBG7.svg';

const GeometricIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" className={styles.icon}>
    <path d="M12 2v20M2 12h20M4.93 4.93l14.14 14.14M4.93 19.07L19.07 4.93" />
    <circle cx="12" cy="12" r="6" />
    <rect x="7.5" y="7.5" width="9" height="9" transform="rotate(45 12 12)" />
  </svg>
);

const VALUES_DATA = [
  {
    id: 1,
    title: "Craft First",
    text: "Some things cannot be rushed. Every batch begins with quiet attention — small batches, carefully chosen ingredients, and the kind of patience that mass production will never understand. Great beer carries the fingerprints of the person who made it."
  },
  {
    id: 2,
    title: "Local Produce",
    text: "Every beer begins with a question: what does this land grow, and what can we make with it? Our ingredients come from local farmers in Pune and Maharashtra — not as a marketing line, but as a commitment. Happy customers. Growing farmers. A stronger local economy."
  },
  {
    id: 3,
    title: "Community Roots",
    text: "Berli was born in Kharadi and built for Pune. We believe a great taproom is more than a bar — it is a gathering place. Warm, unpretentious, and proud of its craft without ever making you feel like an outsider for not knowing everything about it."
  },
  {
    id: 4,
    title: "Loyal Buddy",
    text: "Berli knows what it means to show up, every single day, without fail. We see that same loyalty in you. Our regulars are family — and family deserves to be celebrated. Ask us about the Berli Loyalty Program, made for the ones who keep coming back."
  }
];

const ValuesSection = () => {
  return (
    <section className={styles.section}>

      {/* Sketch watermark — bottom right, 0.3 opacity */}
      <img src={sketchImg} alt="" aria-hidden="true" className={styles.watermark} />

      <div className={styles.container}>

        <div className={styles.textContent}>
          <h4 className={styles.overline}>Values</h4>
          <h2 className={styles.heading}>What We<br />Believe</h2>
        </div>

        <div className={styles.cardsGrid}>
          {VALUES_DATA.map((val) => (
            <div key={val.id} className={styles.card}>
              <div className={styles.iconWrapper}>
                <GeometricIcon />
              </div>
              <h3 className={styles.cardTitle}>{val.title}</h3>
              <p className={styles.cardText}>{val.text}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default ValuesSection;